import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getStudentDetails = async () => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.PROFILE.GET_DETAILS);
  return response;
};

export const getEnrolledSessions = async () => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.PROFILE.GET_ENROLLED_SESSIONS);
  return response;
};

export const requestProfileEdit = async (payload) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.PROFILE.EDIT_REQUEST, payload);
  return response;
};

export const uploadStudentPhoto = async (formData) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.PROFILE.UPLOAD_PHOTO, formData);
  return response;
};

export const getEditRequestStatus = async (studentId) => {
  const response = await studentApi.get(`${STUDENT_ENDPOINTS.PROFILE.EDIT_REQUEST_STATUS}/${studentId}`);
  return response;
};
